<template>
    <div>
        <vue-ads-pagination
            :total-items="pagination.total"
            :max-visible-pages="5"
            :items-per-page="pagination.per_page"
            :page="pagination.current_page - 1"
            :loading="loading"
            @page-change="pageChange"
            @range-change="rangeChange"
            class="items-center h-10"
        >
            <template slot-scope="props">
                <div class="vue-ads-pr-2 vue-ads-leading-loose">
                    {{ props.start }} - {{ props.end }} of {{ props.total }} items
                </div>
            </template>
            <template
                slot="buttons"
                slot-scope="props"
            >
                <div class="pagination-buttons flex space-x-1">
                    <vue-ads-page-button
                        v-for="(button, key) in props.buttons"
                        :key="key"
                        v-bind="button"
                        @page-change="pageChange(button.page)"
                        :disable-styling="true"
                        :title="button.title"
                        class="rounded hover:bg-white focus:shadow w-9 h-9 font-bold transition"
                        :class="{'opacity-30 cursor-not-allowed': button.disabled, 'bg-white shadow' : button.active }"
                        :html="button.title == `previous` ? `<svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'><polyline points='15 18 9 12 15 6'></polyline></svg>` : button.title == `next` ? `<svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'><polyline points='9 18 15 12 9 6'></polyline></svg>` : typeof button.page === 'string' ? button.page : (button.page + 1).toString()"
                    />
                </div>
            </template>
        </vue-ads-pagination>
    </div>
</template>

<script>
import 'vue-ads-pagination/dist/vue-ads-pagination.css';
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';

export default {
    name: 'pagination',

    components: {
        VueAdsPagination,
        VueAdsPageButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
            required: false
        },
        total: {
            type: Number,
            default: 0,
            required: true,
        },
        per_page: {
            type: Number,
            default: 30,
            required: false,
        }
    },
    data(){
          return {
                pagination: {
                    current_page: 1,
                    per_page: this.per_page,
                    from: 0,
                    to: 0,
                    total: this.total
                }
          }
    },
    methods: {
        pageChange (page) {
            this.pagination.current_page = page + 1
            this.$emit('page-changed', page + 1)
        },

        rangeChange (start, end) {
            this.$emit('range-changed', {start, end})
        },
    },
};
</script>
<style lang="sass">
    .pagination-buttons
        button
            span
                svg
                    margin: 0 auto
</style>
